module.exports = __webpack_public_path__ + "img/insight--icon.d360ea87.svg";